export default "__VITE_ASSET__B3Bnrn66__"